import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-06c0ac09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-animation-container" }
const _hoisted_2 = { class: "animation-container" }
const _hoisted_3 = { class: "loading-animation" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DotLottieVue = _resolveComponent("DotLottieVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DotLottieVue, {
          style: {"height":"200px","width":"200px"},
          autoplay: "",
          loop: "",
          src: "/assets/loader.lottie"
        }),
        _createElementVNode("h4", null, _toDisplayString(_ctx.loadingTitleText), 1),
        (_ctx.loadingDescription)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_4, _toDisplayString(_ctx.loadingDescription), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}